import { EmailFormValues } from "./types";


export const SENDER_EMAIL = "autobiz@orytron.com";

export const initialEmailForm: EmailFormValues = {
  subject: "",
  content: "",
  replyTo: "",
  ccTenantEmail: false,
  newEmail: "",
  contactEmails: [],
  additionalEmails: [],
  pdfAttachment: null,
  pdfAttachmentSelected: true,
  additionalFiles: [],
};
